import { NarrativeForm } from '../../utils/schema';
import { NARRATIVE_VALUATOR_QUERY_FIELD_MAP } from '../../utils/transformation';

export type NarrativeMiniValuatorScreen = 'valuation' | 'companySelect';
export const NARRATIVE_MINI_VALUATOR_COMPANY_QUERY_PARAM = 'valuatorcompany';

type NarrativeMiniValuatorAppendModifiedFieldsOptions = {
  values: NarrativeForm;
  dirty: Record<keyof NarrativeForm, boolean>;
  pathname: string;
};

export const narrativeMiniValuatorAppendModifiedFields = ({
  values,
  dirty,
  pathname,
}: NarrativeMiniValuatorAppendModifiedFieldsOptions) => {
  // Note hostname gets ignored, but we just need to set something
  const url = new URL(pathname, 'https://simplywall.st');
  Object.entries(dirty)
    .filter(
      ([key, isDirty]) =>
        isDirty && key in NARRATIVE_VALUATOR_QUERY_FIELD_MAP && values[key]
    )
    .forEach(([key]) => {
      url.searchParams.set(
        NARRATIVE_VALUATOR_QUERY_FIELD_MAP[key].name,
        values[key]
      );
    });

  return `${url.pathname}${url.search}`;
};
